import { render, staticRenderFns } from "./JobCardDetails.vue?vue&type=template&id=15d63b90&"
import script from "./JobCardDetails.vue?vue&type=script&lang=js&"
export * from "./JobCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports